import store from '../../store'
import {addMeetingToGCalRequest} from '../../actions/meetings'


export function addMeetingToGCal(meeting,docUrl) {	
	return store.dispatch(addMeetingToGCalRequest(meeting,docUrl))
}

